import Vue from 'vue';
import * as _ from 'lodash';
import OfferService from '@/app/offer/offer.service';
import { offerDepartmentEnum } from '@/shared/enum';
import download from 'downloadjs';

const getDefaultSchiebetuerAnsteuerungZubehoer = () => ({
    deckeneinbausatzWeiss203608: false,
    montagewinkelSchwarz203609: false,
    wetterhaubeSchwarz203610: false,
    deckeneinbausatzSchwarz151253: false,
    deckeneinbausatzWeiss151254: false,
    regenabdeckung158250: false,
    deckenwinkel151256: false,
    deckenwinkel153568: false,
    rundbogenadapter151255: false,
    interfaceGc363S151361: false,
    deckeneinbausatz160288: false,
    montagewinkel160286: false,
    wetterhaube160287: false,
});

const getDefaultItem = () => ({
    _id: null,
    receivedVia: null,
    csnr: null,
    receivedDate: null,
    receivedFrom: null,
    debitor: null,
    tp: null,
    objekt: null,
    objektdaten: null,
    bauObjektNr: null,
    plz: null,
    contactPerson: null,
    customerEmail: null,
    contactPersonTelNr: null,
    opmUser: null,
    ofmUser: null,
    deliveryDate: null,
    status: null,
    deleteFilesDate: null,
    abteilung: {
        autSchieber: false,
        autDreher: false,
        bau: false,
        umbau: false,
        export: false,
        ersatzteile: false,
    },
    ktb: null,
    ampel: null,
    notes: [],
    files: [],
    aktuelle_abteilung: offerDepartmentEnum.OFFER,
    angebot: {
        offerNr: null,
        offerDate: null,
        offerSum: null,
        offerFollowUpDate: null,
        talkResult: null,
        notes: [],
    },
    opm: {
        orderFollowUpDate: null,
        ampel: null,
        orderId: null,
        status: null,
        notes: [],
    },
    stammdaten: {
        gewuenschterMontageTermin: null,
        infoZumMontageTermin: null,
        tueren: [
            {
                tuerTyp: 'keine',
                stueckzahl: null,
            },
        ],
        ansprechpartner: {
            kunde: {
                name: null,
                telNr: null,
                email: null,
            },
            bauleitung: {
                name: null,
                telNr: null,
                email: null,
            },
            elektriker: {
                name: null,
                telNr: null,
                email: null,
            },
            baustelle: {
                name: null,
                telNr: null,
                email: null,
            },
            uebergabeEinschulung: {
                name: null,
                telNr: null,
                email: null,
            },
            servicebericht: {
                name: null,
                telNr: null,
                email: null,
            },
            entscheidungstraeger: {
                name: null,
                telNr: null,
                email: null,
            },
        },
        kabelplanVersandtAn: null,
        verhandlungsprotokollVersandtAn: null,
    },
    schiebetuer: {
        montageposition: {
            abklaerungVorOrtNaturmass: null,
            montageposition: null,
            ortsangabe: null,
            partnerpreis: false,
        },
        farbe: {
            typ: null,
            farbe: null,
            glanzgrad: null,
            pulvernummer: null,
            ralZweigeteilt: null,
            sonstiges: null,
        },
        antriebstyp: {
            typ: null,
            sonderfunktion: null,
            bmaUmwandler: false,
            winterstellungReduzierung: null,
            haube: null,
            geteilteHaube: null,
            geteilteHaubeLaengeLinks: null,
            geteilteHaubeLaengeRechts: null,
            revisionsklappeLaenge: null,
            verriegelung: null,
        },
        varianteAbmessungen: {
            variante: null,
            oberlichtDurchGeze: null,
            raumhoehe: null,
            schliessrichtung: null,
            wandleisten: null,
            pfostenanlaufprofil: null,
            profil: null,
            tuervariante: null,
            oeffnungsweite: null,
            durchgangshoehe: null,
            mauerlichteBreite: null,
            antriebslaenge: null,
            antriebslaengeAsymmetrisch: false,
            antriebslaengeLinks: null,
            antriebslaengeRechts: null,
        },
        befestigungAntrieb: {
            befestigung: null,
        },
        einbauartAntrieb: {
            wandbefestigung: false,
            sturzmontageMitSeitenteil: false,
            sturzmontageBaumassBreite: null,
            sturzmontageBaumassHoehe: null,
            wandmontageMitSeitenteilLaibung: false,
            wandmontageLaibungBaumassBreite: null,
            wandmontageLaibungBaumassHoehe: null,
            freitragenderTraegerOhneSeitenteil: false,
            freitragenderTraegerOhneMontageplatte: null,
            freitragenderTraegerMitSeitenteilLaibung: false,
            freitragenderTraegerMitSeitenteilLaibungMontageplatte: null,
            freitragenderTraegerMitSeitenteilWandmontage: false,
            freitragenderTraegerMitMontageplatte: null,
        },
        fluegelart: {
            esgGlasbeschlag: false,
            isoGlasbeschlag: false,
            gcProfileTherm: false,
            igg: false,
            ggs: false,
            fsg: false,
            brandschutzfluegel: false,
            systemhersteller: null,
            fluegelBauseits: false,
            fluegelBauseitsStaerke: null,
            fluegelBauseitsTyp: null,
            glas: null,
            sonderglas: null,
            sonderglasBeschreibung: null,
            seehoeheMeter: null,
        },
        sicherungsSchutzfluegel: {
            sicherungsfluegel: false,
            antriebsseiteLinksRiegelabstand: null,
            antriebsseiteLinksPfostenabstand: null,
            antriebsseiteRechtsRiegelabstand: null,
            antriebsseiteRechtsPfostenabstand: null,
            sicherungsfluegelbeschlagEv185585: false,
            sicherungsfluegelSonstigesAufdopplung: null,
            schutzfluegel: [],
            sonderlaengeBisEndeAntrieb: false,
            sonstigesAufdopplung: null,
        },
        bodenfuehrung: {
            bodenfuehrung: null,
            laenge: null,
            entwaesserung: null,
            fussbodenheizungVorhanden: false,
        },
        bodenschloss: {
            bodenschloss: null,
            riegelLang: false,
            profilhalbzylinder: null,
        },
        ansteuerung: {
            antriebsseiten: [
                {
                    ansteuerelement: 'keine',
                    stueckzahl: null,
                    pos: null,
                    zubehoer: getDefaultSchiebetuerAnsteuerungZubehoer(),
                },
            ],
            antriebsgegenseiten: [
                {
                    ansteuerelement: 'keine',
                    stueckzahl: null,
                    pos: null,
                    zubehoer: getDefaultSchiebetuerAnsteuerungZubehoer(),
                },
            ],
            festfeldabsicherungNskAntriebsseite: 'keine',
            festfeldabsicherungNskStueckzahl: null,
            festfeldabsicherungNskPos: null,
            festfeldabsicherungNskZubehoer: getDefaultSchiebetuerAnsteuerungZubehoer(),
            funkSender: 'keine',
            funkSenderStueckzahl: null,
            funkSenderProgrammierung: null,
            funkEmpfaenger: 'keine',
            funkEmpfaengerStueckzahl: null,
            funkEmpfaengerPos: null,
            funkSenderGegenseite: 'keine',
            funkSenderGegenseiteStueckzahl: null,
            funkSenderGegenseiteProgrammierung: null,
            funkEmpfaengerGegenseite: 'keine',
            funkEmpfaengerGegenseiteStueckzahl: null,
            funkEmpfaengerGegenseitePos: null,
        },
        programmschalter: {
            programmschalter: null,
            positionProgrammschalter: null,
            profilzylinder: false,
            apMontage: null,
            abdeckrahmen: null,
            blindabdeckungAs500: false,
            anmerkungen: null,
        },
        brandschutz: {
            rsz7: false,
            rsz7Stueckzahl: null,
            rsz7Position: null,
            rauchmelderGc152: false,
            rauchmelderGc152Stueckzahl: null,
            rauchmelderGc152Position: null,
            wandwinkelRauchmelder: false,
            wandwinkelRauchmelderStueckzahl: null,
            wandwinkelRauchmelderPosition: null,
            wirelessKitGc170: false,
            wirelessKitGc170Stueckzahl: null,
            wirelessKitGc170Position: null,
            unterbrechertasterAs500: false,
            unterbrechertasterAs500Stueckzahl: null,
            unterbrechertasterAs500Position: null,
            apDose1fach: false,
            apDose1fachStueckzahl: null,
            apDose1fachPosition: null,
            sonstiges: null,
        },
        zusaetzlicheAnbindung: {
            zuko: false,
            zukoFunktionsbeschreibung: null,
            gebaeudeleittechnik: false,
            gebaeudeleittechnikFunktionsbeschreibung: null,
            zeitschaltuhr: false,
            zeitschaltuhrFunktionsbeschreibung: null,
            zusGezeTheben: false,
            zusGezeThebenFunktionsbeschreibung: null,
            programmierungDurchGeze: false,
            programmierungDurchGezeAbklaerungsblattZsuLink: null,
            platineGeze103: false,
            platineGeze103Funktionsbeschreibung: null,
            uebergabebox: 'keine',
            uebergabeboxAktiv: false,
        },
        sonderfunktionSteuerung: {
            pe1Funktion: null,
            pe1FunktionBeschreibung: null,
            pe2Funktion: null,
            pe2FunktionBeschreibung: null,
            pe3Funktion: null,
            pe3FunktionBeschreibung: null,
            pa1Relaiskontakt: null,
            pa1RelaiskontaktFunktionsbeschreibung: null,
            pa2TransKontakt24v: null,
            pa2TransKontakt24vFunktionsbeschreibung: null,
            rp224Geze183709: false,
        },
        usv: {
            usvBauseits: false,
            ablerex1000va500w: false,
            schaltschrankUsvRTec: false,
            halterung260x155x400: false,
            alberex1600va900w: false,
            halterung260x155x400Zweite: false,
        },
        zusaetzlicheAnforderungSkizzen: {
            kabelplan: false,
            kabelplanGesandtAn: null,
            grundrissplanOderZeichnung: false,
            handskizze: false,
            cad: false,
            anmerkungFreitext: null,
        },
    },
    schiebetueren: [],
    drehtuer: {
        montageposition: {
            abklaerungVorOrtNaturmass: null,
            montageposition: null,
            ortsangabe: null,
            partnerpreis: false,
        },
        farbe: {
            typ: null,
            farbe: null,
            glanzgrad: null,
            pulvernummer: null,
            ralZweigeteilt: null,
            sonstiges: null,
        },
        antriebstyp: {
            typ: null,
            elektronischeSchliessfolgerung: false,
            servoantrieb: false,
            lowEnergyModus: false,
            tuerfreischaltungSmartSwing: false,
            wcSteuerungLedBesetzt: false,
            brandfallsteuerungBehinderte: false,
            brandfallsteuerungDruckluftbelueftung: false,
            bsBestandstuereZustimmungserklaerung: false,
        },
        montageartenAbmessungen: {
            montageart: null,
            gleitschiene: false,
            gestaenge: false,
            fluegel: null,
            fluegelbreite: null,
            gf: null,
            sf: null,
            fluegelhoehe: null,
            fluegelgewicht: null,
            leibungstiefe: null,
            tuerueberschlag: null,
            tuervariante: null,
            dinRichtung: null,
        },
        befestigung: {
            wand: null,
            tuerblatt: null,
            tuerblattSonstiges: null,
            tuerblattAusfuehrung: null,
        },
        achsverlaengerung: {
            achsverlaengerung: null,
            bolzenverlaengerung: null,
        },
        anschlag: {
            anschlag: null,
            verantwortung: null,
        },
        haubenanbausatzVerlaengerung: {
            haubenanbausatzVerlaengerung: null,
            laenge: null,
            verwendung: null,
        },
        sicherheitssensoren: {
            gc342Kit: false,
            gc342KitTyp: null,
            gc342KitStueckzahl: null,
            gc342PlusLinkesModul: false,
            gc342PlusLinkesModulTyp: null,
            gc342PlusLinkesModulStueckzahl: null,
            gc342PlusRechtesModul: false,
            gc342PlusRechtesModulTyp: null,
            gc342PlusRechtesModulStueckzahl: null,
            gc342PlusLinkesModulZweite: false,
            gc342PlusLinkesModulZweiteTyp: null,
            gc342PlusLinkesModulZweiteStueckzahl: null,
            position: null,
            apDose1fach: false,
            apDose1fachStueckzahl: null,
            apDose1fachPosition: null,
            sonstiges: false,
            sonstigesText: null,
        },
        zusaetzlicheAnbindung: {
            zuko: false,
            zukoFunktionsbeschreibung: null,
            gebaeudeleittechnik: false,
            gebaeudeleittechnikFunktionsbeschreibung: null,
            zeitschaltuhr: false,
            zeitschaltuhrFunktionsbeschreibung: null,
            zusGezeTheben: false,
            zusGezeThebenFunktionsbeschreibung: null,
            programmierungDurchGeze: false,
            programmierungDurchGezeAbklaerungsblattZsuLink: null,
            platineGeze103: false,
            platineGeze103Funktionsbeschreibung: null,
            uebergabebox: 'keine',
        },
        sonderfunktionSteuerung: {
            pe1Funktion: null,
            pe1FunktionBeschreibung: null,
            pe2Funktion: null,
            pe2FunktionBeschreibung: null,
            pe3Funktion: null,
            pe3FunktionBeschreibung: null,
            pa1Relaiskontakt: null,
            pa1RelaiskontaktFunktionsbeschreibung: null,
            pa2TransKontakt24v: null,
            pa2TransKontakt24vFunktionsbeschreibung: null,
            rp224Geze183709: false,
        },
        usv: {
            usvBauseits: false,
            ablerex1000va500w: false,
            schaltschrankUsvRTec: false,
            halterung260x155x400: false,
            alberex1600va900w: false,
            halterung260x155x400Zweite: false,
        },
        zusaetzlicheAnforderungSkizzen: {
            kabelplan: false,
            kabelplanGesandtAn: null,
            grundrissplanOderZeichnung: false,
            handskizze: false,
            cad: false,
            anmerkungFreitext: null,
        },
    },
    drehtueren: [],
    ersatzteile: {
        orderNumber: null,
        orderDate: null,
        orderSum: null,
        civilAcceptance: null,
        implementationDate: null,
        freigabeZurVerrechnung: null,
        invoiceValue: null,
        notes: [],
    },
});

const getDefaultLastSearch = () => ({
    type: null,
    value: null,
});

const getDefaultState = () => ({
    item: getDefaultItem(),
    list: [],
    currentPage: 1,
    totalPages: 1,
    lastSearch: getDefaultLastSearch(),
});

const hasContactValue = (value) => value != null && value.toString().trim() !== '';

const normalizeSchiebetuerAnsteuerungElement = (value) => {
    const mapping = {
        'Kombimelder GC 363+ R GEZE ID 203854': 'Kombimelder GC 363+ R 203854',
        'Kombimelder GC 363+ SF GEZE ID 203856': 'Kombimelder GC 363+ SF 203856',
        'Lichtvorhang GC339+ GEZE ID 203858': 'Lichtvorhang GC 339+ 203858',
        'Kombimelder GC 363 R GEZE ID 160283': 'Kombimelder GC 365 R 160283',
        'Kombimelder GC 363 SF GEZE ID 160284': 'Kombimelder GC 365 SF 160284',
        'GC 308 R silber und weiß': 'GC 308 R silber',
        'FT Edelstahl AP 119898': 'Flächentaster Edelstahl AP 119898',
    };
    return mapping[value] || value || 'keine';
};

const normalizeSchiebetuerFestfeldabsicherungNskElement = (value) => {
    const mapping = {
        'GC 308 silber und weiß': 'GC 308 silber',
    };
    return mapping[value] || value || 'keine';
};

const removeDeprecatedSchiebetuerFields = (schiebetuer) => {
    if (!schiebetuer?.zusaetzlicheAnforderungSkizzen) {
        return;
    }
    delete schiebetuer.zusaetzlicheAnforderungSkizzen.kundenplanVorhanden;
    delete schiebetuer.zusaetzlicheAnforderungSkizzen.optionalAnbieten;
};

const normalizeCustomerContactFields = (offer) => {
    if (!offer) return offer;

    const normalizedOffer = JSON.parse(JSON.stringify(offer));
    const defaults = getDefaultItem();
    if (!normalizedOffer.stammdaten) {
        normalizedOffer.stammdaten = JSON.parse(JSON.stringify(defaults.stammdaten));
    }
    if (!normalizedOffer.stammdaten.ansprechpartner) {
        normalizedOffer.stammdaten.ansprechpartner = JSON.parse(JSON.stringify(defaults.stammdaten.ansprechpartner));
    }
    if (!normalizedOffer.stammdaten.ansprechpartner.kunde) {
        normalizedOffer.stammdaten.ansprechpartner.kunde = JSON.parse(JSON.stringify(defaults.stammdaten.ansprechpartner.kunde));
    }
    if (!normalizedOffer.schiebetuer) {
        normalizedOffer.schiebetuer = JSON.parse(JSON.stringify(defaults.schiebetuer));
    }
    if (!Array.isArray(normalizedOffer.schiebetueren)) {
        normalizedOffer.schiebetueren = [JSON.parse(JSON.stringify(normalizedOffer.schiebetuer))];
    }
    removeDeprecatedSchiebetuerFields(normalizedOffer.schiebetuer);
    normalizedOffer.schiebetueren.forEach((schiebetuer) => removeDeprecatedSchiebetuerFields(schiebetuer));
    if (!normalizedOffer.drehtuer) {
        normalizedOffer.drehtuer = JSON.parse(JSON.stringify(defaults.drehtuer));
    }
    if (!Array.isArray(normalizedOffer.drehtueren)) {
        normalizedOffer.drehtueren = [JSON.parse(JSON.stringify(normalizedOffer.drehtuer))];
    }
    for (let sectionKey of Object.keys(defaults.drehtuer)) {
        if (!normalizedOffer.drehtuer[sectionKey]) {
            normalizedOffer.drehtuer[sectionKey] = JSON.parse(JSON.stringify(defaults.drehtuer[sectionKey]));
            continue;
        }
        for (let fieldKey of Object.keys(defaults.drehtuer[sectionKey])) {
            if (normalizedOffer.drehtuer[sectionKey][fieldKey] === undefined) {
                normalizedOffer.drehtuer[sectionKey][fieldKey] = defaults.drehtuer[sectionKey][fieldKey];
            }
        }
    }
    normalizedOffer.drehtueren.forEach((drehtuer) => {
        for (let sectionKey of Object.keys(defaults.drehtuer)) {
            if (!drehtuer[sectionKey]) {
                drehtuer[sectionKey] = JSON.parse(JSON.stringify(defaults.drehtuer[sectionKey]));
                continue;
            }
            for (let fieldKey of Object.keys(defaults.drehtuer[sectionKey])) {
                if (drehtuer[sectionKey][fieldKey] === undefined) {
                    drehtuer[sectionKey][fieldKey] = defaults.drehtuer[sectionKey][fieldKey];
                }
            }
        }
    });
    for (let sectionKey of Object.keys(defaults.schiebetuer)) {
        if (!normalizedOffer.schiebetuer[sectionKey]) {
            normalizedOffer.schiebetuer[sectionKey] = JSON.parse(JSON.stringify(defaults.schiebetuer[sectionKey]));
            continue;
        }
        for (let fieldKey of Object.keys(defaults.schiebetuer[sectionKey])) {
            if (normalizedOffer.schiebetuer[sectionKey][fieldKey] === undefined) {
                normalizedOffer.schiebetuer[sectionKey][fieldKey] = defaults.schiebetuer[sectionKey][fieldKey];
            }
        }
    }
    if (
        !Array.isArray(normalizedOffer.schiebetuer.ansteuerung.antriebsseiten) ||
        normalizedOffer.schiebetuer.ansteuerung.antriebsseiten.length === 0
    ) {
        normalizedOffer.schiebetuer.ansteuerung.antriebsseiten = [JSON.parse(JSON.stringify(defaults.schiebetuer.ansteuerung.antriebsseiten[0]))];
    }
    const firstAntriebsseite = normalizedOffer.schiebetuer.ansteuerung.antriebsseiten[0];
    const hasLegacyAntriebsseite =
        normalizedOffer.schiebetuer.ansteuerung.antriebsseite ||
        normalizedOffer.schiebetuer.ansteuerung.antriebsseiteStueckzahl ||
        normalizedOffer.schiebetuer.ansteuerung.antriebsseitePos;
    const firstAntriebsseiteIsEmpty = firstAntriebsseite.ansteuerelement === 'keine' && !firstAntriebsseite.stueckzahl && !firstAntriebsseite.pos;
    if (hasLegacyAntriebsseite && firstAntriebsseiteIsEmpty) {
        firstAntriebsseite.ansteuerelement = normalizeSchiebetuerAnsteuerungElement(normalizedOffer.schiebetuer.ansteuerung.antriebsseite || 'keine');
        firstAntriebsseite.stueckzahl = normalizedOffer.schiebetuer.ansteuerung.antriebsseiteStueckzahl || null;
        firstAntriebsseite.pos = normalizedOffer.schiebetuer.ansteuerung.antriebsseitePos || null;
    }
    for (let antriebsseite of normalizedOffer.schiebetuer.ansteuerung.antriebsseiten) {
        const defaultAntriebsseite = defaults.schiebetuer.ansteuerung.antriebsseiten[0];
        for (let field of ['ansteuerelement', 'stueckzahl', 'pos']) {
            if (antriebsseite[field] === undefined) {
                antriebsseite[field] = defaultAntriebsseite[field];
            }
        }
        if (!antriebsseite.zubehoer) {
            antriebsseite.zubehoer = JSON.parse(JSON.stringify(defaultAntriebsseite.zubehoer));
        }
        for (let key of Object.keys(defaultAntriebsseite.zubehoer)) {
            if (antriebsseite.zubehoer[key] === undefined) {
                antriebsseite.zubehoer[key] = defaultAntriebsseite.zubehoer[key];
            }
            if (normalizedOffer.schiebetuer.ansteuerung[key] === true && firstAntriebsseite === antriebsseite) {
                antriebsseite.zubehoer[key] = true;
            }
        }
        antriebsseite.ansteuerelement = normalizeSchiebetuerAnsteuerungElement(antriebsseite.ansteuerelement);
    }
    if (
        !Array.isArray(normalizedOffer.schiebetuer.ansteuerung.antriebsgegenseiten) ||
        normalizedOffer.schiebetuer.ansteuerung.antriebsgegenseiten.length === 0
    ) {
        normalizedOffer.schiebetuer.ansteuerung.antriebsgegenseiten = [JSON.parse(JSON.stringify(defaults.schiebetuer.ansteuerung.antriebsgegenseiten[0]))];
    }
    if (
        normalizedOffer.schiebetuer.ansteuerung.antriebsgegenseite &&
        normalizedOffer.schiebetuer.ansteuerung.antriebsgegenseiten[0].ansteuerelement === 'keine'
    ) {
        normalizedOffer.schiebetuer.ansteuerung.antriebsgegenseiten[0].ansteuerelement = normalizedOffer.schiebetuer.ansteuerung.antriebsgegenseite;
    }
    for (let antriebsgegenseite of normalizedOffer.schiebetuer.ansteuerung.antriebsgegenseiten) {
        const defaultAntriebsgegenseite = defaults.schiebetuer.ansteuerung.antriebsgegenseiten[0];
        for (let field of ['ansteuerelement', 'stueckzahl', 'pos']) {
            if (antriebsgegenseite[field] === undefined) {
                antriebsgegenseite[field] = defaultAntriebsgegenseite[field];
            }
        }
        if (!antriebsgegenseite.zubehoer) {
            antriebsgegenseite.zubehoer = JSON.parse(JSON.stringify(defaultAntriebsgegenseite.zubehoer));
        }
        for (let key of Object.keys(defaultAntriebsgegenseite.zubehoer)) {
            if (antriebsgegenseite.zubehoer[key] === undefined) {
                antriebsgegenseite.zubehoer[key] = defaultAntriebsgegenseite.zubehoer[key];
            }
        }
        antriebsgegenseite.ansteuerelement = normalizeSchiebetuerAnsteuerungElement(antriebsgegenseite.ansteuerelement);
    }
    normalizedOffer.schiebetuer.ansteuerung.festfeldabsicherungNskAntriebsseite = normalizeSchiebetuerFestfeldabsicherungNskElement(
        normalizedOffer.schiebetuer.ansteuerung.festfeldabsicherungNskAntriebsseite
    );
    if (!normalizedOffer.schiebetuer.ansteuerung.festfeldabsicherungNskZubehoer) {
        normalizedOffer.schiebetuer.ansteuerung.festfeldabsicherungNskZubehoer = JSON.parse(
            JSON.stringify(defaults.schiebetuer.ansteuerung.festfeldabsicherungNskZubehoer)
        );
    }
    for (let key of Object.keys(defaults.schiebetuer.ansteuerung.festfeldabsicherungNskZubehoer)) {
        if (normalizedOffer.schiebetuer.ansteuerung.festfeldabsicherungNskZubehoer[key] === undefined) {
            normalizedOffer.schiebetuer.ansteuerung.festfeldabsicherungNskZubehoer[key] =
                defaults.schiebetuer.ansteuerung.festfeldabsicherungNskZubehoer[key];
        }
    }
    if (normalizedOffer.schiebetuer.programmschalter) {
        const programmschalter = normalizedOffer.schiebetuer.programmschalter;
        if (!programmschalter.positionProgrammschalter && programmschalter.programmschalterInfo) {
            programmschalter.positionProgrammschalter = programmschalter.programmschalterInfo;
        }
        if (programmschalter.blindabdeckungAs500 === undefined && programmschalter.bildabdeckungAS500 !== undefined) {
            programmschalter.blindabdeckungAs500 = programmschalter.bildabdeckungAS500;
        }
        if (!programmschalter.anmerkungen && programmschalter.anmerkung) {
            programmschalter.anmerkungen = programmschalter.anmerkung;
        }
    }
    if (normalizedOffer.schiebetuer.bodenfuehrung) {
        const fussbodenheizungVorhanden = normalizedOffer.schiebetuer.bodenfuehrung.fussbodenheizungVorhanden;
        normalizedOffer.schiebetuer.bodenfuehrung.fussbodenheizungVorhanden =
            fussbodenheizungVorhanden === true || fussbodenheizungVorhanden === 'ja';
    }
    if (normalizedOffer.schiebetuer.bodenschloss) {
        const riegelLang = normalizedOffer.schiebetuer.bodenschloss.riegelLang;
        normalizedOffer.schiebetuer.bodenschloss.riegelLang = riegelLang === true || riegelLang === 'ja';
    }
    if (normalizedOffer.schiebetuer.fluegelart) {
        const fluegelart = normalizedOffer.schiebetuer.fluegelart;
        fluegelart.fluegelBauseits = fluegelart.fluegelBauseits === true || !!fluegelart.fluegelBauseitsStaerke || !!fluegelart.fluegelBauseitsTyp;
    }

    const kunde = normalizedOffer.stammdaten.ansprechpartner.kunde;
    const fields = [
        { legacy: 'contactPerson', stammdaten: 'name' },
        { legacy: 'customerEmail', stammdaten: 'email' },
        { legacy: 'contactPersonTelNr', stammdaten: 'telNr' },
    ];

    for (let field of fields) {
        const legacyValue = normalizedOffer[field.legacy];
        const stammdatenValue = kunde[field.stammdaten];

        if (!hasContactValue(stammdatenValue) && hasContactValue(legacyValue)) {
            kunde[field.stammdaten] = legacyValue;
        } else if (legacyValue !== stammdatenValue) {
            normalizedOffer[field.legacy] = stammdatenValue;
        }
    }

    return normalizedOffer;
};

const offer = {
    namespaced: true,
    state: Object.assign({}, getDefaultState()),
    mutations: {
        update(state, data) {
            Vue.set(state, 'item', normalizeCustomerContactFields(data));
        },
        updateList(state, data) {
            Vue.set(state, 'list', data);
        },
        updateCurrentPage(state, data) {
            Vue.set(state, 'currentPage', data);
        },
        updateTotalPages(state, data) {
            Vue.set(state, 'totalPages', data);
        },
        updateLastSearch(state, data) {
            Vue.set(state, 'lastSearch', data);
        },
        clear(state) {
            Vue.set(state, 'item', JSON.parse(JSON.stringify(getDefaultState().item)));
            Vue.set(state, 'list', JSON.parse(JSON.stringify(getDefaultState().list)));
        },
        clearLastSearch(state) {
            Vue.set(state, 'lastSearch', JSON.parse(JSON.stringify(getDefaultState().lastSearch)));
        },
    },
    actions: {
        clear({ commit }) {
            commit('clear');
        },
        clearLastSearch({ commit }) {
            commit('clearLastSearch');
        },
        updateLastSearch(context, lastSearch) {
            context.commit('updateLastSearch', lastSearch);
        },
        async create(context, client_data) {
            const { data } = await OfferService.create(client_data);
            context.commit('update', data);
            return data;
        },
        async update(context, client_data) {
            const { data } = await OfferService.update(client_data.offer._id, client_data);
            context.commit('update', data);
            return data;
        },
        async query(context, params) {
            const { data } = await OfferService.query(params);
            let currPage = params && params.params && params.params.page ? params.params.page : 0;
            context.commit('updateCurrentPage', currPage);
            let totalPages = data.pages;
            context.commit('updateTotalPages', _.ceil(totalPages));
            context.commit('updateList', data);
            return data;
        },
        async get(context, id) {
            const { data } = await OfferService.get(id);
            context.commit('update', data);
            return data;
        },
        async updateOffer(context, client_data) {
            const offer = client_data;
            context.commit('update', offer);
            return offer;
        },
        async getFile(context, client_data) {
            const data = await OfferService.getFile(client_data.blobId);
            let serverFileName = '';
            if (data.headers['content-disposition']) {
                if (data.headers['content-disposition'].split('filename=')[1]) {
                    serverFileName = data.headers['content-disposition'].split('filename=')[1];
                }
            }
            let contentType = 'application/pdf';
            if (data.headers['content-type']) {
                contentType = data.headers['content-type'];
            }
            let fileName = 'Angebotsanhang.txt';
            if (serverFileName !== '' || serverFileName != null) {
                fileName = serverFileName;
            }
            download(new Blob([data.data]), fileName, contentType);
        },
        async getUpdatedAt(context, id) {
            const { data } = await OfferService.getUpdatedAt(id);
            return data;
        },
    },

    getters: {
        data(state) {
            return state.item;
        },
        list(state) {
            return state.list;
        },
        currentPage(state) {
            return state.currentPage;
        },
        totalPages(state) {
            return state.totalPages;
        },
        lastSearch(state) {
            return state.lastSearch;
        },
    },
};
export { getDefaultItem };
export default offer;
